import { translate } from '../../../i18n/I18nProvider';
import capitaliseFirstLetter from '../../../utils/capitaliseFirstLetter';

export const translateLabel = (label, returnNull = false) => {
  const translations = {
    action: capitaliseFirstLetter(translate('ACTION')),
    identifier: translate('IDENTIFIER'),
    configuration: translate('CONFIGURATION'),
    'phone-and-sim-card.activation-date': translate('ACTIVATION_DATE'),
    'user-info.user-info-navn': translate('NAME'),
    'phone-and-sim-card.resources-phone-numbers-primary': translate(
      'USER.PHONE_NUMBER'
    ),
    'main-package.mp-refill': translate('SUBSCRIPTIONS.REFILL')
  };

  return translations[label] || (returnNull ? null : label);
};

export const translateIdentifier = identifier => {
  const translations = {
    SRV_TELEPO_USER_V1: 'Connect 3.0 User',
    SRV_QUOTE_SUBSCRIPTION_V1: translate('REQUEST_NEW_USER.SUBSCRIPTION')
  };
  return translations[identifier] || identifier;
};

export const translateValue = value => {
  const translations = {
    add: translate('ADD'),
    modify: translate('MODIFY')
  };
  return translations[value?.toLowerCase()] || value;
};

export const translateType = type => {
  const translations = {
    subscription: translate('REQUEST_NEW_USER.SUBSCRIPTION')
  };
  return translations[type?.toLowerCase()] || type;
};
